import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import VideoPlayer from "./VideoPlayer";

export default function SelectedImageDisplay({
  selectedImage, embiggened = false, inPopup = false,
  callbacks, productGroup = {}, ...props
}) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    // clear error when image changes
    if (failed)
      setFailed(false);
  }, [selectedImage]);

  const handleError = evt => {
    window.ERR1 = Object.assign({}, evt);
    setFailed(true);
  }

  if (failed) {
    return <div className="bg-gray-100 relative aspect-3/2">
      <div className="centered text-center text-2xl">
        <div className="text-center text-4xl">
          <span className="fal fa-bug" />
        </div>
        there was a 404 but I caught it for you
      </div>
    </div>
  }

  if (!selectedImage) return <div/>

  if (selectedImage.flavour === 'video') {
    // This prevents two copies from playing at the same time.
    if (inPopup || !embiggened) {
      return <VideoPlayer
        video={selectedImage}
        callbacks={callbacks}/>
    }
  }

  const path = inPopup ? selectedImage.lg :
    selectedImage.md || selectedImage.lg || selectedImage.thumb || selectedImage.sm;

  const handleClick = evt => {
    evt.preventDefault();
    callbacks.setEmbiggened(true);
  }

  return <div className="bg-gray-100 relative">
    <img src={path} className="mx-auto my-auto max-w-full max-h-full"
      onClick={handleClick}
      onError={handleError}
      alt={productGroup?.name}
    />
  </div>
}

